import { render, staticRenderFns } from "./PerformanceQuotientEdit.vue?vue&type=template&id=0a159bae&scoped=true"
import script from "./PerformanceQuotientEdit.vue?vue&type=script&lang=js"
export * from "./PerformanceQuotientEdit.vue?vue&type=script&lang=js"
import style0 from "./PerformanceQuotientEdit.vue?vue&type=style&index=0&id=0a159bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a159bae",
  null
  
)

export default component.exports